
export const GET_VENDOR_PROFILE_SUCCESS = 'GET_VENDOR_PROFILE_SUCCESS';
export const GET_VENDOR_PROFILE_REQUEST = 'GET_VENDOR_PROFILE_REQUEST';
export const GET_VENDOR_PROFILE_FAILURE = 'GET_VENDOR_PROFILE_FAILURE';

export const UPDATE_VENDOR_PROFILE_SUCCESS = 'UPDATE_VENDOR_PROFILE_SUCCESS';
export const UPDATE_VENDOR_PROFILE_REQUEST = 'UPDATE_VENDOR_PROFILE_REQUEST';
export const UPDATE_VENDOR_PROFILE_FAILURE = 'UPDATE_VENDOR_PROFILE_FAILURE';


